export const firebaseConfig = {
  apiKey: 'AIzaSyDLl-8sJyTZgm_ikhyGxGd4eEt8swxykj8',
  authDomain: 'whatsapp-clone-b6cf2.firebaseapp.com',
  projectId: 'whatsapp-clone-b6cf2',
  storageBucket: 'whatsapp-clone-b6cf2.appspot.com',
  messagingSenderId: '900655615187',
  appId: '1:900655615187:web:ae169cd458c12e80cc5826',
};
